import { render, staticRenderFns } from "./measurement.table.vue?vue&type=template&id=5f848669&"
import script from "./measurement.table.vue?vue&type=script&lang=js&"
export * from "./measurement.table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports